<template lang="html">
  <div class="stack">
    <div class="stack-status">
      <i class="pe-7s-lock locked" v-if="capsulePublished"></i>
      <span :class="className" v-else></span>
    </div>
    <div class="stack-icon" @click="goTo()">
      <component :is="componentName" class="icon-svg" />
    </div>
    <div class="stack-number">{{ layerProductCount }}</div>
  </div>
</template>

<script>
// Icons
import IconAccessories1 from "@/components/capsuleBuilder/icons/IconAccessories1";
import IconAccessories2 from "@/components/capsuleBuilder/icons/IconAccessories2";
import IconBottoms from "@/components/capsuleBuilder/icons/IconBottoms";
import IconFootwear from "@/components/capsuleBuilder/icons/IconFootwear";
import IconInnerwear from "@/components/capsuleBuilder/icons/IconInnerwear";
import IconMidwear from "@/components/capsuleBuilder/icons/IconMidwear";
import IconOuterwear from "@/components/capsuleBuilder/icons/IconOuterwear";

// Other
import { mapGetters } from "vuex";

export default {
  components: {
    IconOuterwear,
    IconMidwear,
    IconInnerwear,
    IconBottoms,
    IconFootwear,
    IconAccessories1,
    IconAccessories2
  },

  props: {
    capsulePublished: {
      type: Boolean,
      required: true
    },

    layer: {
      type: Object,
      required: true
    },

    layerGroupInfo: {
      type: Object,
      required: true
    }
  },

  data() {
    return {};
  },

  mounted() {},

  beforeDestroy() {},

  computed: {
    ...mapGetters(["currentCapsule", "currentCapsuleLayers"]),

    layerProductCount() {
      return this.layer.layer_products_count;
    },

    className() {
      return this.layerProductCount >= this.layerGroupInfo["minimum"]
        ? "valid"
        : "invalid";
    },

    componentName() {
      return "Icon" + this.capitalize(this.layer.slug);
    }
  },

  methods: {
    goTo() {
      const el = document.querySelector(`#${this.layer.slug}`);
      el && el.scrollIntoView();
    },

    capitalize(string) {
      return string.replace(/^\w/, c => c.toUpperCase());
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.stack {
  min-width: 150px;

  .stack-status {
    text-align: right;
    padding-right: 12px;
    font-size: 14px;
    color: $grey1;

    .valid::before {
      color: $emerald;
      content: "✓";
    }

    .invalid::before {
      color: $alizarin;
      content: "✗";
    }

    .locked {
      font-style: bold;
    }
  }

  .stack-icon {
    cursor: pointer;
    padding: 15px 30px;
    border-right: 1px solid $grey4;

    &.stack-icon-last {
      border-right: none;
    }

    .icon-svg /deep/ {
      height: 70px;
      width: auto;
      path {
        fill: $grey3;
      }
    }
  }

  .stack-number {
    padding-top: 10px;
    padding-bottom: 50px;
    color: $grey2;
    line-height: 32px;
    font-size: 16px;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/capsuleBuilder/StackItem.vue